// import { AppConfig } from "../Components/Navigation/NavBar";
import { navbarConfigs } from "../Components/AppBar/AppBarConfigs";
import { AppConfig } from "../Objects/interfaces/NavBarInterface";

export interface BrandConfig {
  name: string;
  displayName: string;
  domain: string;
  fontFamily: string;

  colors: {
    primary: string;
    secondary: string;
    accent: string;
    light: string;
    dark: string;
    background: string;
    text: string;
    success: string;
    warning: string;
    error: string;
    profile: string;
  };
  assets: {
    logo: string;
    logoWhite: string;
    favicon: string;
    faviconWhite: string;
    heroImage: string;
    backgroundImage: string;
    stepIcon: string; // Optionnel pour les étapes
  };
  content: {
    tagline: string;
    description: string;
    homeTitle: string;
    homeSubtitle: string;
    registerTitle: string;
    loginTitle: string;
  };
  features: {
    enableSportsCoaching: boolean;
    enableSAP: boolean;
    enableTeacherRegistration: boolean;
    enableClientRegistration: boolean;
  };
  meta: {
    title: string;
    description: string;
    keywords: string[];
    
  };
  appConfig: AppConfig;
}

// Configuration Teach'r (professeurs particuliers)
export const teachrConfigs: BrandConfig = {
  name: "teachr",
  displayName: "Teach'r",
  domain: "teachr.fr",
  fontFamily: "Nunito",
  colors: {
    primary: "#0054A3",
    secondary: "#219cff",
    accent: "#ff724f",
    light: "#5c9fff",
    dark: "#004066",
    background: "#F2F5FB",
    text: "#4D4D4D",
    success: "#27ae60",
    warning: "#FFCE31",
    error: "#E92727",
    profile: "#92D3FF",
  },
  assets: {
    logo: "/brandteachr/logo.svg",
    logoWhite: "/brands/teachr/logo-white.svg",
    favicon: "/brands/teachr/fiveicon.png",
    faviconWhite: "/brands/teachr/logo-white.svg",
    heroImage: "/brands/teachr/hero-image.svg",
    backgroundImage: "/brands/teachr/background.svg",
    stepIcon: "/Assets/Images/step_icon.svg",
  },
  content: {
    tagline: "Donnez et prenez des cours particuliers",
    description:
      "La solution complète qui vous permet d'accéder à l'Avance Immédiate de Crédit d'Impôt et de trouver de nouveaux élèves grâce à de la publicité digitale.",
    homeTitle: "Bienvenue sur Teach'r",
    homeSubtitle: "Votre plateforme de cours particuliers",
    registerTitle: "Inscription - Teach'r",
    loginTitle: "Connexion - Teach'r",
  },
  features: {
    enableSportsCoaching: false,
    enableSAP: false,
    enableTeacherRegistration: true,
    enableClientRegistration: true,
  },
  meta: {
    title: "Teach'r",
    description:
      "La solution complète qui vous permet d'accéder à l'Avance Immédiate de Crédit d'Impôt et de trouver de nouveaux élèves grâce à de la publicité digitale.",
    keywords: [
      "cours particuliers",
      "professeurs",
      "éducation",
      "apprentissage",
    ],
  },
  appConfig: navbarConfigs.teachr,
};

// Configuration Verified Trainer (coachs sportifs)
export const verifiedTrainerConfig: BrandConfig = {
  name: "verified-trainer",
  displayName: "Verified Trainer",
  domain: "verified-trainer.com",
  fontFamily: "Inter",
  colors: {
    primary: "#0dcebf",
    secondary: "#34454e",
    accent: "#34454e",
    light: "#FFB366",
    dark: "#8B4513",
    background: "#E8FCFB", //E8FCFB
    text: "#2F4F4F",
    success: "#32CD32",
    warning: "#FFA500",
    error: "#DC143C",
    profile: "#0FF0DD",
  },
  assets: {
    logo: "/brands/verified-trainer/logo.png",
    logoWhite: "/brands/verified-trainer/logo-white.png",
    favicon: "/brands/verified-trainer/fiveicon.png",
    faviconWhite: "/brands/verified-trainer/faviconWhite.png",
    heroImage: "/brands/verified-trainer/hero-image.svg",
    backgroundImage: "/brands/verified-trainer/background.svg",
    stepIcon: "/brands/verified-trainer/icons/step_icon2.svg",
  },
  content: {
    tagline: "Entraînez-vous avec des coachs sportifs certifiés",
    description:
      "Plateforme de mise en relation avec des coachs sportifs professionnels",
    homeTitle: "Bienvenue sur Verified Trainer",
    homeSubtitle: "Votre plateforme de coaching sportif",
    registerTitle: "Inscription - Verified Trainer",
    loginTitle: "Connexion - Verified Trainer",
  },
  features: {
    enableSportsCoaching: true,
    enableSAP: false,
    enableTeacherRegistration: true,
    enableClientRegistration: true,
  },
  meta: {
    title: "Verified Trainer - Réseau de coachs sportifs vérifiés",
    description:
      "Plateforme de mise en relation avec des coachs sportifs professionnels",
    keywords: ["coaching sportif", "entraîneur", "fitness", "sport"],
  },
  appConfig: navbarConfigs.verifiedTainer,
};

// Configuration Déclarons (SAP)
export const declaronsConfigs: BrandConfig = {
  name: "declarons",
  displayName: "Déclarons",
  domain: "declarons.fr",
  fontFamily: "Crimson Pro",
  colors: {
    primary: "#0A2674",
    secondary: "#7585B1",
    accent: "#4B6AD8",
    light: "#E4EAFF",
    dark: "#4A148C",
    background: "#E4EAFF",
    text: "#2B2B2B",
    success: "#4CAF50",
    warning: "#FF9800",
    error: "#F44336",
    profile: "#92D3FF",
  },
  assets: {
    logo: "/brands/declarons/logo.png",
    logoWhite: "/brands/declarons/logo-white.png",
    favicon: "/brands/declarons/fiveicon.svg",
    faviconWhite: "/brands/declarons/fiveiconWhite.svg",
    heroImage: "/brands/declarons/hero-image.svg",
    backgroundImage: "/brands/declarons/background.svg",
    stepIcon: "/src/Assets/Images/step_icon.svg",
  },
  content: {
    tagline: "Simplifiez vos déclarations administratives",
    description: "Plateforme de services administratifs et de déclarations",
    homeTitle: "Bienvenue sur Déclarons",
    homeSubtitle: "Votre plateforme de services administratifs",
    registerTitle: "Inscription - Déclarons",
    loginTitle: "Connexion - Déclarons",
  },
  features: {
    enableSportsCoaching: false,
    enableSAP: true,
    enableTeacherRegistration: false,
    enableClientRegistration: true,
  },
  meta: {
    title: "Déclarons - Services administratifs en ligne",
    description: "Plateforme de services administratifs et de déclarations",
    keywords: [
      "services administratifs",
      "déclarations",
      "administration",
      "papiers",
    ],
  },
  appConfig: navbarConfigs.declarons,
};

// Fonction pour détecter automatiquement la marque basée sur le domaine ou la variable d'environnement
export const getBrandConfig = (): BrandConfig => {
  // Vérifier d'abord la variable d'environnement (pour les builds)
  const envBrand = process.env.REACT_APP_BRAND;
  if (envBrand) {
    switch (envBrand.toLowerCase()) {
      case "verified-trainer":
        return verifiedTrainerConfig;
      case "verifiedtrainer":
        return verifiedTrainerConfig;
      case "declarons":
        return declaronsConfigs;
      case "teachr":
      default:
        return teachrConfigs;
    }
  }

  // Fallback pour le SSR ou si pas de variable d'environnement
  if (typeof window === "undefined") {
    return teachrConfigs;
  }

  // Détection automatique basée sur le domaine
  const hostname = window.location.hostname.toLowerCase();

  if (
    hostname.includes("verified-trainer") ||
    hostname.includes("verifiedtrainer")
  ) {
    return verifiedTrainerConfig;
  } else if (hostname.includes("declarons")) {
    return declaronsConfigs;
  } else {
    // Par défaut Teach'r
    return teachrConfigs;
  }
};

// Configuration par défaut (pour les tests et le développement)
export const defaultBrandConfig = teachrConfigs;

// Export de toutes les configurations
export const allBrandConfigs = {
  teachr: teachrConfigs,
  verifiedTrainer: verifiedTrainerConfig,
  declarons: declaronsConfigs,
};
